const es = {
    accepted: 'El campo :attribute debe ser aceptado.',
    after: 'El campo :attribute debe ser una fecha posterior a :after.',
    alpha: 'El campo :attribute solo debe contener letras.',
    alpha_dash: 'El campo :attribute solo debe contener letras, números y guiones.',
    alpha_num: 'El campo :attribute solo debe contener letras y números.',
    attributes: {},
    between: 'El campo :attribute tiene que estar entre :min - :max.',
    confirmed: 'La confirmación de :attribute no coincide.',
    different: 'El campo :attribute y :other deben ser diferentes.',
    digits: 'El campo :attribute debe tener :digits dígitos.',
    digits_between: 'El campo :attribute debe tener entre :min y :max dígitos.',
    email: 'El campo :attribute no es un correo válido.',
    in: 'El campo :attribute es inválido.',
    integer: 'El campo :attribute debe ser un número entero.',
    hex: 'El campo :attribute debe tener formato hexadecimal.',
    max: {
        numeric: 'El campo :attribute no debe ser mayor a :max.',
        string: 'El campo :attribute no debe ser mayor que :max caracteres.',
    },
    min: {
        numeric: 'El tamaño del campo :attribute debe ser de al menos :min.',
        string: 'El campo :attribute debe contener al menos :min caracteres.',
    },
    not_in: 'El campo :attribute es inválido.',
    numeric: 'El campo :attribute debe ser numérico.',
    present: 'El campo de :attribute debe estar presente (pero puede estar vacío).',
    regex: 'El formato del campo :attribute es inválido.',
    required: 'El campo :attribute es obligatorio.',
    required_if: 'El campo :attribute es obligatorio cuando :other es :value.',
    same: 'El campo :attribute y :same deben coincidir.',
    size: {
        numeric: 'El tamaño del campo :attribute debe ser :size.',
        string: 'El campo :attribute debe contener :size caracteres.',
    },
    url: 'El formato de :attribute es inválido.',
};
export default es;
